module.exports = __webpack_public_path__ + "static/gl-phone-2470c1cb64ba89cfe6f87dd6c25b5ff9.jpg";